module.exports = __webpack_public_path__ + "img/table_yellowdark.93d79d9d.png";